define('SageDotCom/Components/Videos/VideoListing',[
    "jquery",
    "SageDotCom/Components/Videos/YoutubeVideo",
    "SageDotCom/DataLayer/tealium",
    "SageDotCom/DataLayer/Events/searchRefinement",
    "SageDotCom/Utility/sanitizer"
],
    function ($, Youtube, tealium, searchRefinement, sanitizer) {
        function VideoListing(scope, stateChange, playMessage, pauseMessage, playInModal) {
            // Function to be called when the iframe is added
            function initializeTracking(videoScope) {
                const args = {};
                args.scope = videoScope;
                args.stateChange = stateChange;
                args.playMessage = playMessage;
                args.pauseMessage = pauseMessage;
                args.playInModal = playInModal;
                args.guid = $(this).data("guid");
                Youtube.init(args);

                //Handle modal showing as first click fallback
                setTimeout(function () {
                    var $modalVideo = $(".modal", videoScope);
                    $modalVideo.modal("show");
                }, 250);
            }

            //List of videos on the page, within sage-video-listing
            var $youtubeVideo = $(".youtube-video-section", scope);

            $youtubeVideo.each(function () {
                const currentElement = $(this)[0];
                // Select all elements in witch we'll observe
                const targetNode = currentElement;

                // Options for the observer (include the subtree so it observes all descendants)
                const observerConfig = { childList: true, subtree: true };

                // Callback function to execute when mutations are observed
                const callback = function (mutationsList, observer) {
                    for (const mutation of mutationsList) {
                        if (mutation.type === "childList") {
                            // Check if the added nodes are iframes
                            const addedNodes = mutation.addedNodes;
                            for (const node of addedNodes) {
                                if (node.tagName === "IFRAME") {
                                    // Find the parent element with class 'sage-video-component'
                                    const parentComponent = $(node).closest(".sage-video-component");

                                    // If an iframe is added, initialize tracking
                                    initializeTracking(parentComponent);
                                    // Disconnect the observer as it's no longer needed
                                    observer.disconnect();
                                    
                                    //Continue observing the next video
                                    return;
                                }
                            }
                        }
                    }
                };

                const observer = new MutationObserver(callback);
                observer.observe(targetNode, observerConfig);
            });

            $(".pagination-container a", scope).click(function (el) {
                const eventObj = searchRefinement.GenerateEventMetadata(el.currentTarget, null, GetRefinements(el.currentTarget.href), window.location.href);
                tealium.event(eventObj);
            });
        }

        function GetRefinements(url) {
            var refinements = "";
            var parser = document.createElement("a");
            parser.href = url || window.location.href;
            parser.href = sanitizer.stripHtml(decodeURIComponent(parser.href));
            var query = parser.search.substring(1);
            var vars = query.split("&").filter(function (v) { return v !== "" }); // split and remove empty values
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                refinements += pair[0] + ": " + pair[1] + "; ";
            }

            return refinements.trim().replace(/\;$/, ""); // trim and remove any trailing semi colon
        }

        return function initVideoListing(args) {
            return args.IsExperienceEditorEditing
                ? null
                : new VideoListing(args.scope,
                    args.stateChange || [],
                    args.playMessage || [],
                    args.pauseMessage || [],
                    args.playInModal);
        };
    });

